// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Graficos_PegagraficoformaspagtoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Graficos_PegagraficoformaspagtoResponseDados {
forma_pagamento: string[]
valor_formapagto: number[]
}

export type Graficos_PegagraficoformaspagtoResponse = ApiResponse<Graficos_PegagraficoformaspagtoResponseDados>;

registerResponseContract('Graficos_PegagraficoformaspagtoResponse', {
  forma_pagamento:  { type: 'array',   required: true },
  valor_formapagto: { type: 'array',   required: true },
})
